import Feedback from "../Feedback/Feedback";
import TopBar from "../TopBar/Navbar";
import Footer from "../Footer/Footer";
import ZaloLink from "../ZaloLink/ZaloLink";
import { Outlet } from "react-router-dom";
import IconCart from "../IconCart.js/IconCart";

function MainLayout() {
  return (
    <>
      <TopBar />
      <ZaloLink />
      <Feedback />
      <Outlet/>
      <IconCart/>
      {/* <Footer /> */}
    </>
  );
}

export default MainLayout;